const xr = (e) => e.charAt(0).toUpperCase() + e.slice(1), Nr = (e) => e < 10 ? `0${e}` : `${e}`;
function ke(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Ae(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Re = /* @__PURE__ */ function() {
  function e(n) {
    var t = this;
    this._insertTag = function(a) {
      var s;
      t.tags.length === 0 ? t.insertionPoint ? s = t.insertionPoint.nextSibling : t.prepend ? s = t.container.firstChild : s = t.before : s = t.tags[t.tags.length - 1].nextSibling, t.container.insertBefore(a, s), t.tags.push(a);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(t) {
    t.forEach(this._insertTag);
  }, r.insert = function(t) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Ae(this));
    var a = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var s = t.charCodeAt(0) === 64 && t.charCodeAt(1) === 105;
      s && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + t + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !s;
    }
    if (this.isSpeedy) {
      var i = ke(a);
      try {
        i.insertRule(t, i.cssRules.length);
      } catch (o) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(t) && console.error('There was a problem inserting the following rule: "' + t + '"', o);
      }
    } else
      a.appendChild(document.createTextNode(t));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(t) {
      return t.parentNode && t.parentNode.removeChild(t);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), E = "-ms-", F = "-moz-", l = "-webkit-", re = "comm", ne = "rule", te = "decl", $e = "@import", ge = "@keyframes", Ie = "@layer", _e = Math.abs, K = String.fromCharCode, De = Object.assign;
function Ve(e, r) {
  return w(e, 0) ^ 45 ? (((r << 2 ^ w(e, 0)) << 2 ^ w(e, 1)) << 2 ^ w(e, 2)) << 2 ^ w(e, 3) : 0;
}
function ye(e) {
  return e.trim();
}
function Pe(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function d(e, r, n) {
  return e.replace(r, n);
}
function X(e, r) {
  return e.indexOf(r);
}
function w(e, r) {
  return e.charCodeAt(r) | 0;
}
function L(e, r, n) {
  return e.slice(r, n);
}
function $(e) {
  return e.length;
}
function se(e) {
  return e.length;
}
function G(e, r) {
  return r.push(e), e;
}
function Te(e, r) {
  return e.map(r).join("");
}
var J = 1, V = 1, ve = 0, S = 0, y = 0, P = "";
function H(e, r, n, t, a, s, i) {
  return { value: e, root: r, parent: n, type: t, props: a, children: s, line: J, column: V, length: i, return: "" };
}
function M(e, r) {
  return De(H("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Me() {
  return y;
}
function Le() {
  return y = S > 0 ? w(P, --S) : 0, V--, y === 10 && (V = 1, J--), y;
}
function O() {
  return y = S < ve ? w(P, S++) : 0, V++, y === 10 && (V = 1, J++), y;
}
function I() {
  return w(P, S);
}
function Y() {
  return S;
}
function W(e, r) {
  return L(P, e, r);
}
function j(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function be(e) {
  return J = V = 1, ve = $(P = e), S = 0, [];
}
function we(e) {
  return P = "", e;
}
function U(e) {
  return ye(W(S - 1, ee(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function je(e) {
  for (; (y = I()) && y < 33; )
    O();
  return j(e) > 2 || j(y) > 3 ? "" : " ";
}
function ze(e, r) {
  for (; --r && O() && !(y < 48 || y > 102 || y > 57 && y < 65 || y > 70 && y < 97); )
    ;
  return W(e, Y() + (r < 6 && I() == 32 && O() == 32));
}
function ee(e) {
  for (; O(); )
    switch (y) {
      case e:
        return S;
      case 34:
      case 39:
        e !== 34 && e !== 39 && ee(y);
        break;
      case 40:
        e === 41 && ee(e);
        break;
      case 92:
        O();
        break;
    }
  return S;
}
function We(e, r) {
  for (; O() && e + y !== 47 + 10; )
    if (e + y === 42 + 42 && I() === 47)
      break;
  return "/*" + W(r, S - 1) + "*" + K(e === 47 ? e : O());
}
function Ge(e) {
  for (; !j(I()); )
    O();
  return W(e, S);
}
function Ye(e) {
  return we(q("", null, null, null, [""], e = be(e), 0, [0], e));
}
function q(e, r, n, t, a, s, i, o, f) {
  for (var u = 0, c = 0, h = i, v = 0, C = 0, x = 0, p = 1, N = 1, g = 1, b = 0, A = "", T = a, _ = s, R = t, m = A; N; )
    switch (x = b, b = O()) {
      case 40:
        if (x != 108 && w(m, h - 1) == 58) {
          X(m += d(U(b), "&", "&\f"), "&\f") != -1 && (g = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        m += U(b);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        m += je(x);
        break;
      case 92:
        m += ze(Y() - 1, 7);
        continue;
      case 47:
        switch (I()) {
          case 42:
          case 47:
            G(Ue(We(O(), Y()), r, n), f);
            break;
          default:
            m += "/";
        }
        break;
      case 123 * p:
        o[u++] = $(m) * g;
      case 125 * p:
      case 59:
      case 0:
        switch (b) {
          case 0:
          case 125:
            N = 0;
          case 59 + c:
            g == -1 && (m = d(m, /\f/g, "")), C > 0 && $(m) - h && G(C > 32 ? oe(m + ";", t, n, h - 1) : oe(d(m, " ", "") + ";", t, n, h - 2), f);
            break;
          case 59:
            m += ";";
          default:
            if (G(R = ie(m, r, n, u, c, a, o, A, T = [], _ = [], h), s), b === 123)
              if (c === 0)
                q(m, r, R, R, T, s, h, o, _);
              else
                switch (v === 99 && w(m, 3) === 110 ? 100 : v) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    q(e, R, R, t && G(ie(e, R, R, 0, 0, a, o, A, a, T = [], h), _), a, _, h, o, t ? T : _);
                    break;
                  default:
                    q(m, R, R, R, [""], _, 0, o, _);
                }
        }
        u = c = C = 0, p = g = 1, A = m = "", h = i;
        break;
      case 58:
        h = 1 + $(m), C = x;
      default:
        if (p < 1) {
          if (b == 123)
            --p;
          else if (b == 125 && p++ == 0 && Le() == 125)
            continue;
        }
        switch (m += K(b), b * p) {
          case 38:
            g = c > 0 ? 1 : (m += "\f", -1);
            break;
          case 44:
            o[u++] = ($(m) - 1) * g, g = 1;
            break;
          case 64:
            I() === 45 && (m += U(O())), v = I(), c = h = $(A = m += Ge(Y())), b++;
            break;
          case 45:
            x === 45 && $(m) == 2 && (p = 0);
        }
    }
  return s;
}
function ie(e, r, n, t, a, s, i, o, f, u, c) {
  for (var h = a - 1, v = a === 0 ? s : [""], C = se(v), x = 0, p = 0, N = 0; x < t; ++x)
    for (var g = 0, b = L(e, h + 1, h = _e(p = i[x])), A = e; g < C; ++g)
      (A = ye(p > 0 ? v[g] + " " + b : d(b, /&\f/g, v[g]))) && (f[N++] = A);
  return H(e, r, n, a === 0 ? ne : o, f, u, c);
}
function Ue(e, r, n) {
  return H(e, r, n, re, K(Me()), L(e, 2, -2), 0);
}
function oe(e, r, n, t) {
  return H(e, r, n, te, L(e, 0, t), L(e, t + 1, -1), t);
}
function D(e, r) {
  for (var n = "", t = se(e), a = 0; a < t; a++)
    n += r(e[a], a, e, r) || "";
  return n;
}
function qe(e, r, n, t) {
  switch (e.type) {
    case Ie:
      if (e.children.length)
        break;
    case $e:
    case te:
      return e.return = e.return || e.value;
    case re:
      return "";
    case ge:
      return e.return = e.value + "{" + D(e.children, t) + "}";
    case ne:
      e.value = e.props.join(",");
  }
  return $(n = D(e.children, t)) ? e.return = e.value + "{" + n + "}" : "";
}
function Fe(e) {
  var r = se(e);
  return function(n, t, a, s) {
    for (var i = "", o = 0; o < r; o++)
      i += e[o](n, t, a, s) || "";
    return i;
  };
}
function Be(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function Ke(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var Je = function(r, n, t) {
  for (var a = 0, s = 0; a = s, s = I(), a === 38 && s === 12 && (n[t] = 1), !j(s); )
    O();
  return W(r, S);
}, He = function(r, n) {
  var t = -1, a = 44;
  do
    switch (j(a)) {
      case 0:
        a === 38 && I() === 12 && (n[t] = 1), r[t] += Je(S - 1, n, t);
        break;
      case 2:
        r[t] += U(a);
        break;
      case 4:
        if (a === 44) {
          r[++t] = I() === 58 ? "&\f" : "", n[t] = r[t].length;
          break;
        }
      default:
        r[t] += K(a);
    }
  while (a = O());
  return r;
}, Ze = function(r, n) {
  return we(He(be(r), n));
}, ce = /* @__PURE__ */ new WeakMap(), Qe = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, t = r.parent, a = r.column === t.column && r.line === t.line; t.type !== "rule"; )
      if (t = t.parent, !t)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !ce.get(t)) && !a) {
      ce.set(r, !0);
      for (var s = [], i = Ze(n, s), o = t.props, f = 0, u = 0; f < i.length; f++)
        for (var c = 0; c < o.length; c++, u++)
          r.props[u] = s[f] ? i[f].replace(/&\f/g, o[c]) : o[c] + " " + i[f];
    }
  }
}, Xe = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, er = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", rr = function(r) {
  return r.type === "comm" && r.children.indexOf(er) > -1;
}, nr = function(r) {
  return function(n, t, a) {
    if (!(n.type !== "rule" || r.compat)) {
      var s = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (s) {
        for (var i = !!n.parent, o = i ? n.parent.children : (
          // global rule at the root level
          a
        ), f = o.length - 1; f >= 0; f--) {
          var u = o[f];
          if (u.line < n.line)
            break;
          if (u.column < n.column) {
            if (rr(u))
              return;
            break;
          }
        }
        s.forEach(function(c) {
          console.error('The pseudo class "' + c + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + c.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, Ee = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, tr = function(r, n) {
  for (var t = r - 1; t >= 0; t--)
    if (!Ee(n[t]))
      return !0;
  return !1;
}, fe = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, sr = function(r, n, t) {
  Ee(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), fe(r)) : tr(n, t) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), fe(r)));
};
function xe(e, r) {
  switch (Ve(e, r)) {
    case 5103:
      return l + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return l + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return l + e + F + e + E + e + e;
    case 6828:
    case 4268:
      return l + e + E + e + e;
    case 6165:
      return l + e + E + "flex-" + e + e;
    case 5187:
      return l + e + d(e, /(\w+).+(:[^]+)/, l + "box-$1$2" + E + "flex-$1$2") + e;
    case 5443:
      return l + e + E + "flex-item-" + d(e, /flex-|-self/, "") + e;
    case 4675:
      return l + e + E + "flex-line-pack" + d(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return l + e + E + d(e, "shrink", "negative") + e;
    case 5292:
      return l + e + E + d(e, "basis", "preferred-size") + e;
    case 6060:
      return l + "box-" + d(e, "-grow", "") + l + e + E + d(e, "grow", "positive") + e;
    case 4554:
      return l + d(e, /([^-])(transform)/g, "$1" + l + "$2") + e;
    case 6187:
      return d(d(d(e, /(zoom-|grab)/, l + "$1"), /(image-set)/, l + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return d(e, /(image-set\([^]*)/, l + "$1$`$1");
    case 4968:
      return d(d(e, /(.+:)(flex-)?(.*)/, l + "box-pack:$3" + E + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + l + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return d(e, /(.+)-inline(.+)/, l + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if ($(e) - 1 - r > 6)
        switch (w(e, r + 1)) {
          case 109:
            if (w(e, r + 4) !== 45)
              break;
          case 102:
            return d(e, /(.+:)(.+)-([^]+)/, "$1" + l + "$2-$3$1" + F + (w(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~X(e, "stretch") ? xe(d(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (w(e, r + 1) !== 115)
        break;
    case 6444:
      switch (w(e, $(e) - 3 - (~X(e, "!important") && 10))) {
        case 107:
          return d(e, ":", ":" + l) + e;
        case 101:
          return d(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + l + (w(e, 14) === 45 ? "inline-" : "") + "box$3$1" + l + "$2$3$1" + E + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (w(e, r + 11)) {
        case 114:
          return l + e + E + d(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return l + e + E + d(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return l + e + E + d(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return l + e + E + e + e;
  }
  return e;
}
var ar = function(r, n, t, a) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case te:
        r.return = xe(r.value, r.length);
        break;
      case ge:
        return D([M(r, {
          value: d(r.value, "@", "@" + l)
        })], a);
      case ne:
        if (r.length)
          return Te(r.props, function(s) {
            switch (Pe(s, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return D([M(r, {
                  props: [d(s, /:(read-\w+)/, ":" + F + "$1")]
                })], a);
              case "::placeholder":
                return D([M(r, {
                  props: [d(s, /:(plac\w+)/, ":" + l + "input-$1")]
                }), M(r, {
                  props: [d(s, /:(plac\w+)/, ":" + F + "$1")]
                }), M(r, {
                  props: [d(s, /:(plac\w+)/, E + "input-$1")]
                })], a);
            }
            return "";
          });
    }
}, ir = [ar], or = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var t = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(t, function(p) {
      var N = p.getAttribute("data-emotion");
      N.indexOf(" ") !== -1 && (document.head.appendChild(p), p.setAttribute("data-s", ""));
    });
  }
  var a = r.stylisPlugins || ir;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var s = {}, i, o = [];
  i = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(p) {
      for (var N = p.getAttribute("data-emotion").split(" "), g = 1; g < N.length; g++)
        s[N[g]] = !0;
      o.push(p);
    }
  );
  var f, u = [Qe, Xe];
  process.env.NODE_ENV !== "production" && u.push(nr({
    get compat() {
      return x.compat;
    }
  }), sr);
  {
    var c, h = [qe, process.env.NODE_ENV !== "production" ? function(p) {
      p.root || (p.return ? c.insert(p.return) : p.value && p.type !== re && c.insert(p.value + "{}"));
    } : Be(function(p) {
      c.insert(p);
    })], v = Fe(u.concat(a, h)), C = function(N) {
      return D(Ye(N), v);
    };
    f = function(N, g, b, A) {
      c = b, process.env.NODE_ENV !== "production" && g.map !== void 0 && (c = {
        insert: function(_) {
          b.insert(_ + g.map);
        }
      }), C(N ? N + "{" + g.styles + "}" : g.styles), A && (x.inserted[g.name] = !0);
    };
  }
  var x = {
    key: n,
    sheet: new Re({
      key: n,
      container: i,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: s,
    registered: {},
    insert: f
  };
  return x.sheet.hydrate(o), x;
};
function cr(e) {
  for (var r = 0, n, t = 0, a = e.length; a >= 4; ++t, a -= 4)
    n = e.charCodeAt(t) & 255 | (e.charCodeAt(++t) & 255) << 8 | (e.charCodeAt(++t) & 255) << 16 | (e.charCodeAt(++t) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      r ^= (e.charCodeAt(t + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(t + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(t) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var fr = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, ue = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, ur = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", lr = /[A-Z]|^ms/g, Ne = /_EMO_([^_]+?)_([^]*?)_EMO_/g, ae = function(r) {
  return r.charCodeAt(1) === 45;
}, le = function(r) {
  return r != null && typeof r != "boolean";
}, Z = /* @__PURE__ */ Ke(function(e) {
  return ae(e) ? e : e.replace(lr, "-$&").toLowerCase();
}), B = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Ne, function(t, a, s) {
          return k = {
            name: a,
            styles: s,
            next: k
          }, a;
        });
  }
  return fr[r] !== 1 && !ae(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var dr = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, hr = ["normal", "none", "initial", "inherit", "unset"], pr = B, mr = /^-ms-/, gr = /-(.)/g, de = {};
  B = function(r, n) {
    if (r === "content" && (typeof n != "string" || hr.indexOf(n) === -1 && !dr.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var t = pr(r, n);
    return t !== "" && !ae(r) && r.indexOf("-") !== -1 && de[r] === void 0 && (de[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(mr, "ms-").replace(gr, function(a, s) {
      return s.toUpperCase();
    }) + "?")), t;
  };
}
var Se = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function z(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(Se);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return k = {
          name: n.name,
          styles: n.styles,
          next: k
        }, n.name;
      if (n.styles !== void 0) {
        var t = n.next;
        if (t !== void 0)
          for (; t !== void 0; )
            k = {
              name: t.name,
              styles: t.styles,
              next: k
            }, t = t.next;
        var a = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (a += n.map), a;
      }
      return yr(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var s = k, i = n(e);
        return k = s, z(e, r, i);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var o = [], f = n.replace(Ne, function(c, h, v) {
          var C = "animation" + o.length;
          return o.push("const " + C + " = keyframes`" + v.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + C + "}";
        });
        o.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(o, ["`" + f + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + f + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var u = r[n];
  return u !== void 0 ? u : n;
}
function yr(e, r, n) {
  var t = "";
  if (Array.isArray(n))
    for (var a = 0; a < n.length; a++)
      t += z(e, r, n[a]) + ";";
  else
    for (var s in n) {
      var i = n[s];
      if (typeof i != "object")
        r != null && r[i] !== void 0 ? t += s + "{" + r[i] + "}" : le(i) && (t += Z(s) + ":" + B(s, i) + ";");
      else {
        if (s === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(Se);
        if (Array.isArray(i) && typeof i[0] == "string" && (r == null || r[i[0]] === void 0))
          for (var o = 0; o < i.length; o++)
            le(i[o]) && (t += Z(s) + ":" + B(s, i[o]) + ";");
        else {
          var f = z(e, r, i);
          switch (s) {
            case "animation":
            case "animationName": {
              t += Z(s) + ":" + f + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && s === "undefined" && console.error(ur), t += s + "{" + f + "}";
          }
        }
      }
    }
  return t;
}
var he = /label:\s*([^\s;\n{]+)\s*(;|$)/g, Oe;
process.env.NODE_ENV !== "production" && (Oe = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var k, Q = function(r, n, t) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var a = !0, s = "";
  k = void 0;
  var i = r[0];
  i == null || i.raw === void 0 ? (a = !1, s += z(t, n, i)) : (process.env.NODE_ENV !== "production" && i[0] === void 0 && console.error(ue), s += i[0]);
  for (var o = 1; o < r.length; o++)
    s += z(t, n, r[o]), a && (process.env.NODE_ENV !== "production" && i[o] === void 0 && console.error(ue), s += i[o]);
  var f;
  process.env.NODE_ENV !== "production" && (s = s.replace(Oe, function(v) {
    return f = v, "";
  })), he.lastIndex = 0;
  for (var u = "", c; (c = he.exec(s)) !== null; )
    u += "-" + // $FlowFixMe we know it's not null
    c[1];
  var h = cr(s) + u;
  return process.env.NODE_ENV !== "production" ? {
    name: h,
    styles: s,
    map: f,
    next: k,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: h,
    styles: s,
    next: k
  };
}, vr = !0;
function Ce(e, r, n) {
  var t = "";
  return n.split(" ").forEach(function(a) {
    e[a] !== void 0 ? r.push(e[a] + ";") : t += a + " ";
  }), t;
}
var br = function(r, n, t) {
  var a = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (t === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  vr === !1) && r.registered[a] === void 0 && (r.registered[a] = n.styles);
}, wr = function(r, n, t) {
  br(r, n, t);
  var a = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var s = n;
    do
      r.insert(n === s ? "." + a : "", s, r.sheet, !0), s = s.next;
    while (s !== void 0);
  }
};
function pe(e, r) {
  if (e.inserted[r.name] === void 0)
    return e.insert("", r, e.sheet, !0);
}
function me(e, r, n) {
  var t = [], a = Ce(e, t, n);
  return t.length < 2 ? n : a + r(t);
}
var Sr = function(r) {
  var n = or(r);
  n.sheet.speedy = function(o) {
    if (process.env.NODE_ENV !== "production" && this.ctr !== 0)
      throw new Error("speedy must be changed before any rules are inserted");
    this.isSpeedy = o;
  }, n.compat = !0;
  var t = function() {
    for (var f = arguments.length, u = new Array(f), c = 0; c < f; c++)
      u[c] = arguments[c];
    var h = Q(u, n.registered, void 0);
    return wr(n, h, !1), n.key + "-" + h.name;
  }, a = function() {
    for (var f = arguments.length, u = new Array(f), c = 0; c < f; c++)
      u[c] = arguments[c];
    var h = Q(u, n.registered), v = "animation-" + h.name;
    return pe(n, {
      name: h.name,
      styles: "@keyframes " + v + "{" + h.styles + "}"
    }), v;
  }, s = function() {
    for (var f = arguments.length, u = new Array(f), c = 0; c < f; c++)
      u[c] = arguments[c];
    var h = Q(u, n.registered);
    pe(n, h);
  }, i = function() {
    for (var f = arguments.length, u = new Array(f), c = 0; c < f; c++)
      u[c] = arguments[c];
    return me(n.registered, t, Er(u));
  };
  return {
    css: t,
    cx: i,
    injectGlobal: s,
    keyframes: a,
    hydrate: function(f) {
      f.forEach(function(u) {
        n.inserted[u] = !0;
      });
    },
    flush: function() {
      n.registered = {}, n.inserted = {}, n.sheet.flush();
    },
    // $FlowFixMe
    sheet: n.sheet,
    cache: n,
    getRegisteredStyles: Ce.bind(null, n.registered),
    merge: me.bind(null, n.registered, t)
  };
}, Er = function e(r) {
  for (var n = "", t = 0; t < r.length; t++) {
    var a = r[t];
    if (a != null) {
      var s = void 0;
      switch (typeof a) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(a))
            s = e(a);
          else {
            s = "";
            for (var i in a)
              a[i] && i && (s && (s += " "), s += i);
          }
          break;
        }
        default:
          s = a;
      }
      s && (n && (n += " "), n += s);
    }
  }
  return n;
};
export {
  Sr as a,
  xr as c,
  Nr as p
};
